// Our team's Amigo log (D8). Wording from the Amigo design's copy sheet (Amigo log, Amigo log couldn't do, Amigo log no
// results, Row status); FoodAmigos only, so always Amigo, never the assistant.
export default {
  title: 'Dziennik Amigo',
  intro:
    'Każde zgłoszenie obsłużone przez Amigo: o co poproszono, gdzie, kto prosił i kto zatwierdził. Tę stronę widzi tylko FoodAmigos.',
  // The tab list's name for screen readers.
  tabs_label: 'Dziennik Amigo',
  tabs: {
    requests: 'Zgłoszenia',
    gaps: 'Niewykonane',
  },
  filters: {
    restaurant: 'Restauracja',
    all_restaurants: 'Wszystkie restauracje',
    brand: '{{name}} · Marka',
    restaurant_unknown: 'Restauracja {{id}}',
    searching: 'Szukam restauracji…',
    no_restaurant: 'Brak restauracji o nazwie „{{query}}”',
    period: 'Okres',
    start_date: 'Data początkowa',
    end_date: 'Data końcowa',
    refresh: 'Odśwież',
    gap: 'Prośba o: {{request}}',
    change_set: 'Zgłoszenie stojące za jedną zmianą',
    remove: 'Usuń filtr: {{label}}',
    clear: 'Wyczyść filtry',
  },
  columns: {
    steps: 'Kroki',
    when: 'Kiedy',
    request: 'Zgłoszenie',
    restaurant: 'Restauracja',
    asked_by: 'Zgłosił(a)',
    result: 'Wynik',
  },
  show_steps: 'Pokaż kroki: {{request}}',
  approved_by: 'Zatwierdził(a): {{name}}',
  nothing_approved: 'Nic nie zatwierdzono',
  results: {
    applied: 'Zastosowano: {{applied}}',
    applied_skipped: 'Zastosowano: {{applied}} · Pominięto: {{skipped}}',
    partial: 'Zastosowano {{applied}} z {{total}}',
    imported: 'Zaimportowano',
    importing: 'Importowanie',
    waiting: 'Czeka na zatwierdzenie',
    rejected: 'Odrzucono',
    undone: 'Cofnięto',
    partly_undone: 'Cofnięto {{undone}} z {{total}}',
    expired: 'Wygasło',
    replaced: 'Zastąpiono',
    failed: 'Niepowodzenie',
    answered: 'Odpowiedziano',
    not_yet: 'Na razie niewykonalne',
    off_limits: 'Poza zakresem',
    not_allowed: 'Niedozwolone',
    switched_off: 'Wyłączone',
    guard: 'Zatrzymano przez kontrolę bezpieczeństwa',
    not_found: 'Nie znaleziono',
  },
  steps: {
    asked: '{{name}} prosi',
    asked_anonymous: 'Zgłoszono',
    approved: 'Zatwierdził(a): {{name}}',
    approved_alone: 'Zatwierdzono',
    applied_one: 'Zastosowano {{count}} zmianę',
    applied_few: 'Zastosowano {{count}} zmiany',
    applied_many: 'Zastosowano {{count}} zmian',
    applied_other: 'Zastosowano {{count}} zmiany',
    failed_one: 'Nie zastosowano: {{count}}',
    failed_few: 'Nie zastosowano: {{count}}',
    failed_many: 'Nie zastosowano: {{count}}',
    failed_other: 'Nie zastosowano: {{count}}',
    rejected: 'Odrzucono',
    undone: 'Cofnięto',
    undone_by: 'Cofnięto, zatwierdzone przez {{name}}',
    skipped_one: 'Pominięto: {{count}}',
    skipped_few: 'Pominięto: {{count}}',
    skipped_many: 'Pominięto: {{count}}',
    skipped_other: 'Pominięto: {{count}}',
    skipped_state: 'Pominięto',
    more_one: 'i jeszcze {{count}}',
    more_few: 'i jeszcze {{count}}',
    more_many: 'i jeszcze {{count}}',
    more_other: 'i jeszcze {{count}}',
    changes_one: '{{count}} zmiana',
    changes_few: '{{count}} zmiany',
    changes_many: '{{count}} zmian',
    changes_other: '{{count}} zmiany',
    other: 'Sprawdzanie czegoś',
  },
  // The line over a request's steps (QA49): how many, how many shop refused, how many failed.
  summary: {
    steps_one: '{{count}} krok',
    steps_few: '{{count}} kroki',
    steps_many: '{{count}} kroków',
    steps_other: '{{count}} kroku',
    refused_one: '{{count}} odrzuconych',
    refused_few: '{{count}} odrzucone',
    refused_many: '{{count}} odrzuconych',
    refused_other: '{{count}} odrzuconych',
    failed_one: '{{count}} nieudanych',
    failed_few: '{{count}} nieudane',
    failed_many: '{{count}} nieudanych',
    failed_other: '{{count}} nieudanych',
  },
  // A request that changed nothing says what came of it, under Result (design: Log · steps open).
  outcomes: {
    title: 'Wynik',
    answered: 'Odpowiedź: nic się nie zmieniło.',
    waiting: 'Czeka na zatwierdzenie. Nic się jeszcze nie zmieniło.',
    rejected: 'Odrzucono: nic się nie zmieniło.',
    expired: 'Wygasło bez zatwierdzenia: nic się nie zmieniło.',
    replaced: 'Zastąpiono nowszą kartą: nic się tu nie zmieniło.',
    undone: 'Cofnięto: zmiany zostały wycofane.',
    partly_undone: 'Częściowo cofnięto: wycofano {{undone}} z {{total}} zmian.',
    failed: 'Nie udało się: nic się nie zmieniło.',
    not_yet: 'Jeszcze nie można tego zrobić: nic się nie zmieniło. Wliczone w „Nie można zrobić”.',
    off_limits: 'Poza zakresem: nic się nie zmieniło.',
    not_allowed: 'Niedozwolone dla roli tej osoby: nic się nie zmieniło.',
    switched_off: 'Wyłączone tutaj: nic się nie zmieniło.',
    guard: 'Zatrzymano przez zabezpieczenie: nic się nie zmieniło.',
    not_found: 'Nie znaleziono: nic się nie zmieniło.',
    importing: 'Importowanie. Każde danie trafia do Menu → Historia edycji.',
    imported: 'Zaimportowano. Każde danie jest w Menu → Historia edycji.',
  },
  changes: {
    // With where they were made: "3 changes · Hilltop Burger · Ehrenfeld".
    where: '{{changes}} · {{where}}',
    title_one: '{{count}} zmiana',
    title_few: '{{count}} zmiany',
    title_many: '{{count}} zmian',
    title_other: '{{count}} zmiany',
    show_all: 'Pokaż wszystkie zmiany ({{count}})',
    show_fewer: 'Pokaż mniej',
    from: 'z',
    to: 'na',
    removed: 'Usunięto',
  },
  row_states: {
    skipped: 'Pominięto',
    failed: 'Nie zastosowano',
    stale: 'Zmieniono w międzyczasie',
    kept: 'Bez zmian',
  },
  menu_history: 'Otwórz Menu → Historia zmian',
  // Opens the request's chat in the Amigo panel, on its restaurant (read only when someone else started it).
  open_chat: 'Otwórz czat',
  // Both links first switch the dashboard to the request's restaurant; this says that didn't work.
  switch_failed: 'Nie udało się otworzyć tej restauracji. Spróbuj ponownie.',
  pagination: {
    label: 'Strony',
    summary: '{{from}}–{{to}} z {{total}} zgłoszeń',
    previous: 'Poprzednia strona',
    next: 'Następna strona',
  },
  empty: {
    title: 'Brak zgłoszeń dla: {{restaurant}} w tym okresie',
    text: 'Amigo nic tam nie obsłużył(a) między {{from}} a {{to}}.',
    title_any_day: 'Brak zgłoszeń dla: {{restaurant}}',
    text_any_day: 'Amigo nic tam jeszcze nie obsłużył(a).',
    title_everywhere: 'Brak zgłoszeń w tym okresie',
    text_everywhere: 'Amigo nic nie obsłużył(a) między {{from}} a {{to}}.',
    title_nothing: 'Brak zgłoszeń',
    text_nothing: 'Amigo nic jeszcze nie obsłużył(a).',
  },
  loading: 'Ładowanie…',
  error: {
    title: 'Nie udało się wczytać dziennika',
    text: 'Spróbuj ponownie za chwilę.',
    retry: 'Spróbuj ponownie',
  },
  gaps: {
    intro:
      'Czego Amigo jeszcze nie potrafił(a) zrobić, pogrupowane według próśb, od najczęstszych. Próśb spoza zakresu i niedozwolonych dla danej roli tu nie ma.',
    columns: {
      area: 'Obszar',
      request: 'O co prosili użytkownicy',
      count: 'Zgłoszono',
      last_at: 'Ostatnia prośba',
      requests: 'Zgłoszenia',
    },
    count: '{{count}}×',
    see_requests_one: 'Zobacz {{count}} zgłoszenie',
    see_requests_few: 'Zobacz {{count}} zgłoszenia',
    see_requests_many: 'Zobacz {{count}} zgłoszeń',
    see_requests_other: 'Zobacz zgłoszenia: {{count}}',
    today: 'Dziś, {{time}}',
    yesterday: 'Wczoraj, {{time}}',
    empty_title: 'Brak próśb, z którymi Amigo nie mógł sobie poradzić',
    empty_text: 'Amigo mógł zrealizować wszystko, o co prosili użytkownicy.',
  },
  areas: {
    menu: 'Menu',
    hours: 'Godziny otwarcia',
    order_settings: 'Ustawienia zamówień',
    my_info: 'Moje dane',
    marketing: 'Marketing',
    gift_cards: 'Karty podarunkowe',
    reports: 'Raporty',
    website: 'Strona internetowa',
    integrations: 'Integracje',
    delivery: 'Dostawa',
    payments: 'Płatności',
    team: 'Zespół',
    billing: 'Rozliczenia',
    settings: 'Ustawienia',
    other: 'Inne',
  },
};
